const resource = {
    resource_identifier_in_use: '"El identificador de API {{indicator}} ya está en uso',
};
export default Object.freeze(resource);
